export const SEARCH_FIELD_DEBOUNCE_DELAY = 600;
export const SCROLL_DEBOUNCE_DELAY = 100;
export const FILTERS_APPLY_DELAY = 600;
export const FIREFOX_CLEANUP_LINK_DELAY = 500;

export const TABLE_ROW_HEIGHT = 48;
export const INFINITE_SCROLL_BUFFER_ROWS = 4.5;
export const INFINITE_SCROLL_THRESHOLD_PX = TABLE_ROW_HEIGHT * INFINITE_SCROLL_BUFFER_ROWS;

export const MAX_INACTIVE_TIME_MINUTES = 30;
export const UPDATE_INTERVAL_MS = 1000;

export const APP_NAME_HCI = 'hci';
export const APP_NAME_SELF_SERVICE = 'self-service';
